// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"formula-card_wrapper__X1SI4","targeting":"formula-card_targeting__pJCsT","container":"formula-card_container__hAD_P","subtitle":"formula-card_subtitle__lxI5O"};